// API Configuration utility
// Handles different environments without needing .env changes

export const getApiBaseUrl = (): string => {
  // Use environment variable if available, otherwise use defaults based on NODE_ENV
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace('/api', '');
  }
  
  // Fallback based on environment
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3001';
  }
  
  // Production: API is served from the same domain
  return window.location.origin;
};

export const apiCall = async (endpoint: string, options: RequestInit = {}): Promise<Response> => {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}${endpoint}`;
  
  // Always include credentials for CORS
  const defaultOptions: RequestInit = {
    credentials: 'include',
    ...options
  };
  
  return fetch(url, defaultOptions);
};